module.exports = __webpack_public_path__ + "static/img/king_card_2.af687f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/king_card_2.png
// module id = PfsN
// module chunks = 0